import LastArticles from './LastArticles.react';
var Dashboard = function Dashboard() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LastArticles, null));
};
export default Dashboard;